// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","443":"about","487":"qrcode","631":"contact","720":"faq","780":"payresult","974":"qrcodeprcing"}[chunkId] || chunkId) + "." + {"172":"09dd4fc6","177":"41ccb416","443":"1a020d29","487":"c520049e","631":"550b3322","720":"21a7c611","780":"9d8879b3","974":"5f118eb3"}[chunkId] + ".js";
};